// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ws5e","badges":"styles_badges__16cqj"};